import { useCallback, useRef, useState } from 'react';
import CarouselMoreButton from './carouselMoreButton/CarouselMoreButton';
import useScheduledMeasure from '../../../hooks/useScheduledMeasure';
import classes from './RotatingCarousel.module.css';

const MORE_BUTTON_WIDTH = 39;

const RotatingCarousel = ({ items = [], getItemLabel, renderItem }) => {

  const rootRef = useRef(null);
  const itemRef = useRef(null);
  const [orderedItems, setOrderedItems] = useState(items);
  const [visibleCount, setVisibleCount] = useState(items.length);

  const hiddenCount = visibleCount > 0 ? Math.max(0, orderedItems.length - visibleCount) : 0;
  const hiddenNames = hiddenCount > 0 && getItemLabel ? orderedItems.slice(visibleCount).map(getItemLabel) : [];

  const refreshLayout = useCallback(() => {
    const rootEl = rootRef.current;
    const itemWidth = itemRef.current?.offsetWidth;
    if (!rootEl || !itemWidth)
      return;
    let visibleItemCount = Math.min(items.length, Math.floor(rootEl.clientWidth / itemWidth));
    if (visibleItemCount < items.length)
      visibleItemCount = Math.min(items.length, Math.floor((rootEl.clientWidth - MORE_BUTTON_WIDTH) / itemWidth));
    setVisibleCount(Math.max(1, visibleItemCount));
  }, [items.length]);

  useScheduledMeasure(rootRef, refreshLayout);

  if (typeof renderItem !== 'function') 
    return null;

  return (
    <div className={classes.Carousel} ref={rootRef}>
      {visibleCount > 0 ?
        <>
          <ul className={classes.List}>
            {orderedItems.map((item, index) => {
              return (
                <li key={index} ref={index === 0 ? itemRef : undefined} className={classes.ListItem} hidden={index >= visibleCount}>
                  {renderItem({ item, index })}
                </li>
              );
            })}
          </ul>
          <div className={classes.MoreSlot}>
            <CarouselMoreButton
              count={hiddenCount}
              hiddenNames={hiddenNames}
              onClick={() => setOrderedItems(prev => prev.length <= 1 ? prev : [...prev.slice(1), prev[0]])}
            />
          </div>
        </>
       : null}
    </div>
  );
};

export default RotatingCarousel;